import React, { useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { HeaderSubtitleCentered, TextButtonWithDropdownArrow, Image } from 'newComponents'
import ChevronDown from '../../../components/ChevronDown'
import CtaArrow from '../../../components/ctaArrow'
import '../../../styles/press.scss'

const astronautImageQuery = graphql`
  query {
    localFile: file(relativePath: { eq: "press-media/astronaut.png" }) {
      name
      childImageSharp {
        fluid(maxWidth: 1500, quality: 90) {
          aspectRatio
          base64
          originalImg
          originalName
          presentationHeight
          presentationWidth
          sizes
          src
          srcSet
          srcSetWebp
          srcWebp
        }
      }
    }
  }
`

const PressMediaCards = ({ articles: articleObject }) => {
  const { articles } = articleObject

  const astronaut = useStaticQuery(astronautImageQuery)

  const [limit, setLimit] = useState(9)

  const increaseArticleLimit = (e) => {
    e.preventDefault()
    setLimit(limit + 9)
  }

  return (
    <section className="section is-large bg-gradient">
      <div className="container content">
        <HeaderSubtitleCentered header="In the News" subtitle="Read the latest news about LaunchDarkly." />
        <div className="container content columns is-multiline cards">
          {articles.slice(0, limit).map((article) => {
            const { name, date, heading, image, logoFormat, url } = article
            const articleImage = image?.childImageSharp || image?.publicURL ? image : astronaut
            return (
              <div className="article-card column is-one-third-desktop is-half-tablet" key={url}>
                <a href={url} className="card-link" target="_blank" rel="noopener noreferrer">
                  <div className="card-container clickable-card">
                    <div className="card-top pr-card-top">
                      <h5 className="card-source">
                        {name}
                        <br />
                        {date || <br />}
                      </h5>
                      <h3 className="card-title">{heading}</h3>
                    </div>
                    {logoFormat ? (
                      <div className="logo-format-cards has-text-centered">
                        <Image image={articleImage} alt={heading} />
                      </div>
                    ) : (
                      <div className="press-media-image">
                        <Image image={articleImage} alt={heading} />
                      </div>
                    )}
                    <div className="card-bottom">
                      Read More
                      <CtaArrow />
                    </div>
                  </div>
                </a>
              </div>
            )
          })}
        </div>
        {limit <= articles.length && (
          <TextButtonWithDropdownArrow onClick={increaseArticleLimit} text="More Articles &nbsp;" />
        )}
      </div>
    </section>
  )
}

export default PressMediaCards
